module.exports = __webpack_public_path__ + "img/Parcels.b6a5c616.jpg";